import React, { useEffect, useState } from "react"
import { navigate } from "gatsby"
import ThemeContext from "../context/ThemeContext"
import Pwa from "../components/Frontend/Pwa"
import { getParameterByName } from "../utils/helper"
import { Result } from "antd"
import { LoadingOutlined } from "@ant-design/icons"
import "antd/dist/antd.less"
import "../theme/frontend.less"

const Layout = ({ children }) => {
  const [isSSR, setIsSSR] = useState(false)
  const getMode = getParameterByName("mode")
  const actionCode = getParameterByName("oobCode")

  useEffect(() => {
    setIsSSR(true)
    if (getMode && getMode === "resetPassword" && actionCode) {
      navigate("/auth/forgot-password", {
        state: {
          recovery: true,
          code: actionCode,
        },
      })
      return null
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (!isSSR) {
    return (
      <Result
        icon={<LoadingOutlined />}
        title="Loading..."
        subTitle="Please wait while loading."
      />
    )
  } else {
    return (
      <ThemeContext.Consumer>
        {() => {
          return (
            <>
              <div className="frontendLayout">{children}</div>
              <Pwa />
            </>
          )
        }}
      </ThemeContext.Consumer>
    )
  }
}

export default Layout
